import * as React from 'react';
import { ReadyState } from 'react-use-websocket';
import { token, zVar } from '../../ui/theme';
import { useGameWebSocket } from './useGameWebSocket';

/*
 * ConnectionBanner — a fixed strip across the top of the game page whenever the
 * game socket isn't open. The socket auto-reconnects, so this is purely to
 * explain the silence: without it a dropped connection just looks like a game
 * that stopped updating.
 */

const MESSAGES: Partial<Record<ReadyState, string>> = {
  [ReadyState.CONNECTING]: 'Reconnecting…',
  [ReadyState.CLOSING]: 'Connection lost — reconnecting…',
  [ReadyState.CLOSED]: 'Connection lost — reconnecting…',
  [ReadyState.UNINSTANTIATED]: 'Not connected',
};

export const ConnectionBanner: React.FC = () => {
  const { readyState } = useGameWebSocket();
  const message = MESSAGES[readyState];
  if (!message) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: zVar('z-modal'),
        padding: '6px 12px',
        textAlign: 'center',
        background: token('color-lose'),
        color: token('color-text'),
        fontSize: 'var(--font-size-sm)',
        fontWeight: 700,
        letterSpacing: 'var(--letter-spacing-wide)',
      }}
    >
      {message}
    </div>
  );
};

export default ConnectionBanner;
